import { GiTrophyCup } from "react-icons/gi";
import useUserInfo from "../../hooks/useUserInfo";


export default function MainTable({ leaderboard }) {
    const {id} = useUserInfo() || {}
    return (
        <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
            <thead>
                <tr className="border-b border-slate-600/50">
                    <th className="table-th !text-center">Rank</th>
                    <th className="table-th !text-center">Name</th>
                    <th className="table-th !text-center">Quiz Mark</th>
                    <th className="table-th !text-center">Assignment Mark</th>
                    <th className="table-th !text-center">Total</th>
                </tr>
            </thead>

            <tbody>
                {leaderboard.map((item) => {
                    const { serial, student_name, student_id, totalQuizMark, totalAssignmentMark, totalMark } = item || {}
                    return (
                        <tr key={student_id} className={`${student_id === id ?  "border-2 border-cyan": "border-slate-600/50"} border-b`}>
                            <td className="table-td text-center flex justify-center items-center">{serial === 1 ? <GiTrophyCup className="text-[#ffd700]" /> : serial}</td>
                            <td className="table-td text-center">{student_name}</td>
                            <td className="table-td text-center">{totalQuizMark ? totalQuizMark : 0}</td>
                            <td className="table-td text-center">{totalAssignmentMark ? totalAssignmentMark : 0}</td>
                            <td className="table-td text-center">{totalMark ? totalMark : 0}</td>
                        </tr>)
                })}
            </tbody>
        </table>
    )
};